import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";

// รายการที่ "ได้รับเงิน" แต่ธุรกรรมไม่มีฟิลด์ userId ของผู้รับ จึงไม่ถูกค้นเจอด้วย where("userId") ของหน้ากระเป๋า/ประวัติ
//  - ขายสำเร็จ: รายการ release เก็บ sellerId (ผู้ขายได้เงินตามราคาสินค้า)
//  - ส่วนแบ่งคูปอง: รายการ release เดียวกันเก็บ couponOwnerId + couponShare (เจ้าของคูปองได้ส่วนแบ่ง)
// คืนรายการรูปแบบเดียวกับธุรกรรมอื่น (type/amount/createdAt) เพื่อรวมแสดงในลิสต์เดียวกันได้เลย
export default function useIncomeTransactions(uid) {
  const [sales, setSales] = useState([]);
  const [shares, setShares] = useState([]);

  useEffect(() => {
    if (!uid) return undefined;
    const toRows = (snap) => snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    const unsubs = [
      onSnapshot(
        query(collection(db, "transactions"), where("sellerId", "==", uid)),
        (snap) => setSales(toRows(snap).filter((t) => t.type === "release")),
        () => {},
      ),
      onSnapshot(
        query(collection(db, "transactions"), where("couponOwnerId", "==", uid)),
        (snap) => setShares(
          toRows(snap)
            .filter((t) => t.type === "release" && t.couponShare > 0)
            .map((t) => ({ ...t, id: `share-${t.id}`, type: "coupon_share", amount: t.couponShare })),
        ),
        () => {},
      ),
    ];
    return () => unsubs.forEach((u) => u());
  }, [uid]);

  return [...sales, ...shares];
}

export const byNewest = (a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0);
